import { render, staticRenderFns } from "./ServerContextMenu.vue?vue&type=template&id=e60f0894&"
import script from "./ServerContextMenu.vue?vue&type=script&lang=js&"
export * from "./ServerContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports